module.exports = __webpack_public_path__ + "static/media/theresearchtech.56bf7611.png";